export default "__VITE_ASSET__DxFaTWVE__"